


















import {Component, Prop, Vue} from 'vue-property-decorator';
import {QingApp} from '@/entity/QingApp';
import {Customer} from '@/entity/Customer';
import {CustomerDto} from '@/dto/CustomerDto';

@Component({
  components: {},
})
export default class KeShangSelect extends Vue {
  @Prop({default: ''})
  private readonly value!: QingApp;
  @Prop({default: 0})
  private readonly index!: number;
  customerList: Customer[] = [];

  async getCustomer() {
    this.customerList = await CustomerDto.findAll(new Customer());
  }


  handleInput(i: string) {
    this.$emit('input', i);
  }

  mounted() {
    this.getCustomer();
  }

  get selectedCustomerName() {
    const string = this.value.showCustomer[this.index];
    const customer = this.customerList.find(value => value.id === Number(string));
    if (typeof customer !== 'undefined') {
      return customer.name;
    }
    return 'ID:' + string;
  }

  selectedCustomer(c: Customer) {
    return this.value.showCustomer.some(sc => sc + '' === c.id + '');
  }

}
